/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as AppCustomersRouteImport } from './routes/_app/customers'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppDayCloseRouteImport } from './routes/_app/day-close'
import { Route as AppFbrRouteImport } from './routes/_app/fbr'
import { Route as AppInvoicesRouteImport } from './routes/_app/invoices'
import { Route as AppPosRouteImport } from './routes/_app/pos'
import { Route as AppRatesRouteImport } from './routes/_app/rates'
import { Route as AppReportsRouteImport } from './routes/_app/reports'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AppCustomersRoute = AppCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppDayCloseRoute = AppDayCloseRouteImport.update({
  id: '/day-close',
  path: '/day-close',
  getParentRoute: () => AppRoute,
} as any)
const AppFbrRoute = AppFbrRouteImport.update({
  id: '/fbr',
  path: '/fbr',
  getParentRoute: () => AppRoute,
} as any)
const AppInvoicesRoute = AppInvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => AppRoute,
} as any)
const AppPosRoute = AppPosRouteImport.update({
  id: '/pos',
  path: '/pos',
  getParentRoute: () => AppRoute,
} as any)
const AppRatesRoute = AppRatesRouteImport.update({
  id: '/rates',
  path: '/rates',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsRoute = AppReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/customers': typeof AppCustomersRoute
  '/dashboard': typeof AppDashboardRoute
  '/day-close': typeof AppDayCloseRoute
  '/fbr': typeof AppFbrRoute
  '/invoices': typeof AppInvoicesRoute
  '/pos': typeof AppPosRoute
  '/rates': typeof AppRatesRoute
  '/reports': typeof AppReportsRoute
  '/settings': typeof AppSettingsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/customers': typeof AppCustomersRoute
  '/dashboard': typeof AppDashboardRoute
  '/day-close': typeof AppDayCloseRoute
  '/fbr': typeof AppFbrRoute
  '/invoices': typeof AppInvoicesRoute
  '/pos': typeof AppPosRoute
  '/rates': typeof AppRatesRoute
  '/reports': typeof AppReportsRoute
  '/settings': typeof AppSettingsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_app/customers': typeof AppCustomersRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/day-close': typeof AppDayCloseRoute
  '/_app/fbr': typeof AppFbrRoute
  '/_app/invoices': typeof AppInvoicesRoute
  '/_app/pos': typeof AppPosRoute
  '/_app/rates': typeof AppRatesRoute
  '/_app/reports': typeof AppReportsRoute
  '/_app/settings': typeof AppSettingsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/customers'
    | '/dashboard'
    | '/day-close'
    | '/fbr'
    | '/invoices'
    | '/pos'
    | '/rates'
    | '/reports'
    | '/settings'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/customers'
    | '/dashboard'
    | '/day-close'
    | '/fbr'
    | '/invoices'
    | '/pos'
    | '/rates'
    | '/reports'
    | '/settings'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/_app/customers'
    | '/_app/dashboard'
    | '/_app/day-close'
    | '/_app/fbr'
    | '/_app/invoices'
    | '/_app/pos'
    | '/_app/rates'
    | '/_app/reports'
    | '/_app/settings'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/customers': {
      id: '/_app/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof AppCustomersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/day-close': {
      id: '/_app/day-close'
      path: '/day-close'
      fullPath: '/day-close'
      preLoaderRoute: typeof AppDayCloseRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/fbr': {
      id: '/_app/fbr'
      path: '/fbr'
      fullPath: '/fbr'
      preLoaderRoute: typeof AppFbrRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invoices': {
      id: '/_app/invoices'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof AppInvoicesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pos': {
      id: '/_app/pos'
      path: '/pos'
      fullPath: '/pos'
      preLoaderRoute: typeof AppPosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/rates': {
      id: '/_app/rates'
      path: '/rates'
      fullPath: '/rates'
      preLoaderRoute: typeof AppRatesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports': {
      id: '/_app/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AppReportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppCustomersRoute: typeof AppCustomersRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppDayCloseRoute: typeof AppDayCloseRoute
  AppFbrRoute: typeof AppFbrRoute
  AppInvoicesRoute: typeof AppInvoicesRoute
  AppPosRoute: typeof AppPosRoute
  AppRatesRoute: typeof AppRatesRoute
  AppReportsRoute: typeof AppReportsRoute
  AppSettingsRoute: typeof AppSettingsRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppCustomersRoute: AppCustomersRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppDayCloseRoute: AppDayCloseRoute,
  AppFbrRoute: AppFbrRoute,
  AppInvoicesRoute: AppInvoicesRoute,
  AppPosRoute: AppPosRoute,
  AppRatesRoute: AppRatesRoute,
  AppReportsRoute: AppReportsRoute,
  AppSettingsRoute: AppSettingsRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
